<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Auth",
};
</script>

<style scoped>
.dropDownMenu > ul > li:nth-of-type(1) {
  padding: 0 70px;
}
.dropDownMenu > ul {
  padding-right: 100px;
}
</style>
